// extracted by mini-css-extract-plugin
export default {"item":"Form_item__IOkwW","itemContent":"Form_itemContent__ZBdg8"};